import http from '@/utils/http'

export function addUser(data){
    return http.post('/users',data)
}
export function editUser(id,data){
    return http.put(`/users/${id}`,data)
}
export function getUserDetail(id){
    return http(`/users/${id}`)
}
export function deleteUser(id){
    return http.delete(`/users/${id}`)
}
export function getUser(params){
    return http(`/users`,{params})
}

